import { render, staticRenderFns } from "./NhstIpRegistration.vue?vue&type=template&id=33e78a27&scoped=true"
import script from "./NhstIpRegistration.vue?vue&type=script&lang=js"
export * from "./NhstIpRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e78a27",
  null
  
)

export default component.exports